<template>
    <!--  BEGIN SIDEBAR  -->
    <!-- <teleport to="body"> -->
    <!-- <div v-if="pdfOpen" class="pdf-overlay" @click.self="pdfOpen = false"> -->
        <!-- <button class="pdf-close-outer" @click="pdfOpen = false">X</button> -->
        <!-- <div class="pdf-modal"> -->
            <!-- <iframe :src="pdfUrl" width="100%" height="100%" style="border: none;" />
        </div> -->
    <!-- </div> -->
    <!-- </teleport> -->

    <div class="sidebar-wrapper sidebar-theme" :class="specialpage">
        <nav ref="menu" id="sidebar" class = "sidebar-container">
            <div v-if="false" class="shadow-bottom"></div>
            <div class="top-menu-items menu-section">
                
                <ul v-if="!customerhub" class="list-unstyled menu-categories custom-sidebar-scroll " 
                    :class="site?'site':''" 
                    tag="ul" 
                    :options="{ wheelSpeed: 0.5, swipeEasing: !0, minScrollbarLength: 40, maxScrollbarLength: 300, suppressScrollX: true, wheelPropagation: true}">
                        <template v-if="false">
                    <!-- <li class="menu" @click="toggleMobileMenuXXX">
                        <a :href="frontendRoot + '/'" aria-expanded="false" class="dropdown-toggle">
                            <div class="">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="feather feather-home"
                                >
                                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                                    <polyline points="9 22 9 12 15 12 15 22"></polyline>
                                </svg>
                                <span>Home Page</span>
                            </div>
                        </a>
                    </li> -->
                    <!-- <li class="menu" @click="toggleMobileMenuXXX">
                        <a :href="frontendRoot + '/customerhub'" aria-expanded="false" class="dropdown-toggle">
                            <div class="">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="feather feather-home"
                                >
                                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                                    <polyline points="9 22 9 12 15 12 15 22"></polyline>
                                </svg>
                                <span>Customer Hub</span>
                            </div>
                        </a>
                    </li> -->
                    </template>
                    
                    <template v-if="site">
                        <li v-if="mainReportFileExists" class="menu" @click="">
                            <a @click="mainreport" class="dropdown-toggle" :class="mainFileReportClass">Main Report</a>
                        </li>
                        <li class="menu" @click="">
                            <a v-if="gpsState?.type == 'none'" 
                                @click="noLink('GPS')"
                                class="dropdown-toggle"
                                :class="gpsState.link?'':'opacity-50'"
                                >
                                 GPS
                            </a>
                            <a v-else-if="gpsState?.type == 'single'" 
                                :href="gpsState.link" 
                                class="dropdown-toggle" 
                                :class="gpsState.link?'':'opacity-50'"
                                target="_blank"
                                >GPS</a>
                            <template v-else>
                                <a class="dropdown-toggle" 
                                    
                                    data-bs-toggle="collapse" 
                                    data-bs-target="#gpsLinks" 
                                    aria-controls="gpsLinks" 
                                    aria-expanded="false">
                                    <div class="">
                                        <span>GPS</span>
                                    </div>
                                    <div>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            class="feather feather-chevron-right"
                                        >
                                            <polyline points="9 18 15 12 9 6"></polyline>
                                        </svg>
                                    </div>
                                </a>
                                
                                <ul id="gpsLinks" class="collapse submenu list-unstyled" data-bs-parent="#sidebar">
                                    <li v-for="link in gpsState?.links">
                                        <a 
                                            target="_blank" 
                                            :href="link.gpsLink" 
                                            :class="link.gpsLink?'':'opacity-50'"    
                                            @click="toggleMobileMenu">{{link.cellName}}</a>
                                    </li>    
                                </ul>
                            </template>
                        </li>
                        <li class="menu" @click="">
                            <a v-if="siteTourState?.type == 'none'" 
                                @click="noLink('virtual site tour')" 
                                class="dropdown-toggle"
                                :class="siteTourState.link?'x':'opacity-50'"
                                >Virtual Site Tour</a>
                            <a v-else-if="siteTourState?.type == 'single'" 
                                :href="siteTourState.link" 
                                class="dropdown-toggle" 
                                :class="siteTourState.link?'x':'opacity-50'"
                                target="_blank"
                                >Virtual Site Tour</a>
                            <template v-else>
                                <a class="dropdown-toggle" data-bs-toggle="collapse" data-bs-target="#virtTourLinks" aria-controls="virtTourLinks" aria-expanded="false">
                                    <div class="">
                                        <span>Virtual Site Tour</span>
                                    </div>
                                    <div>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            class="feather feather-chevron-right"
                                        >
                                            <polyline points="9 18 15 12 9 6"></polyline>
                                        </svg>
                                    </div>
                                </a>
                                
                                <ul id="virtTourLinks" class="collapse submenu list-unstyled" data-bs-parent="#sidebar">
                                    <li v-for="link in siteTourState?.links">
                                        <a target="_blank" 
                                            :href="link.virtualSiteTourLink" 
                                            :class="link.virtualSiteTourLink?'x':'opacity-50'"
                                            @click="toggleMobileMenu"
                                            >{{link.cellName}}</a>
                                    </li>    
                                </ul>
                            </template>
                        </li>
                        <li class="menu" @click="comingSoon">
                            <a class="dropdown-toggle">3D View</a>
                        </li>
                        
                    </template>

                    
                    <!-- ADMIN MENU-->
                    <li v-if="admin" class="menu">
                        <a class="dropdown-toggle" data-bs-toggle="collapse" data-bs-target="#adminEls" aria-controls="adminEls" aria-expanded="false">
                            <div class="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-wrench-adjustable" viewBox="0 0 16 16">
                                <path d="M16 4.5a4.492 4.492 0 0 1-1.703 3.526L13 5l2.959-1.11c.027.2.041.403.041.61Z"/>
                                <path d="M11.5 9c.653 0 1.273-.139 1.833-.39L12 5.5 11 3l3.826-1.53A4.5 4.5 0 0 0 7.29 6.092l-6.116 5.096a2.583 2.583 0 1 0 3.638 3.638L9.908 8.71A4.49 4.49 0 0 0 11.5 9Zm-1.292-4.361-.596.893.809-.27a.25.25 0 0 1 .287.377l-.596.893.809-.27.158.475-1.5.5a.25.25 0 0 1-.287-.376l.596-.893-.809.27a.25.25 0 0 1-.287-.377l.596-.893-.809.27-.158-.475 1.5-.5a.25.25 0 0 1 .287.376ZM3 14a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"/>
                                </svg>
                                <span>Admin</span>
                            </div>
                            <div>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="feather feather-chevron-right"
                                >
                                    <polyline points="9 18 15 12 9 6"></polyline>
                                </svg>
                            </div>
                        </a>

                        <ul id="adminEls" class="collapse submenu list-unstyled" data-bs-parent="#sidebar">
                            <li>
                                <a target="_blank" href="/tables/users" @click="toggleMobileMenuXXX">Users</a>
                            </li>    
                        </ul>
                    </li>
                    <!-- <li v-if="!site && !customerhub" class="asksurvey">
                        <a href="https://hydrasurvey.ca/ask-a-sludge-surveyor" target="_blank">
                            <img src="@/assets/images/ask%20a%20sludge%20surveyor.png" alt="Project Icon">
                        </a>
                    </li> -->


                    <template v-if="site">

                        <li class="menu first-site-menu"> <!-- @click="toggleMobileMenuXXX" -->
                            <a :href="'/pages/faq'" aria-expanded="false" class="dropdown-toggle" target="_blank" rel="noopener noreferrer">
                            <!-- <a :href="'https://hydrasurvey.ca/knowledge-centre-1'" aria-expanded="false" class="dropdown-toggle"> -->
                                <div class="" style="display: flex; align-items: flex-start;">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="feather feather-book-open"
                                        style="flex-shrink: 0; margin-top: 2px;"
                                    >
                                        <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
                                        <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
                                    </svg>
                                    <span style="white-space: normal; word-break: break-word;">User Guide</span>
                                </div>
                            </a>
                        </li>
                        <li v-if="relatedProjects && relatedProjects.length > 0" class="related-header">
                            RELATED PROJECTS
                        </li>
                        <li v-for="project in relatedProjects">
                            <a 
                                :href="'/site/'+clientId+'/'+project.id"
                                :title="project.year + ' ' + project.name"
                                class="project-link"
                            >
                                {{ (project.year + ' ' + project.name).length > 25 ? (project.year + ' ' + project.name).slice(0, 25) + '...' : (project.year + ' ' + project.name)  }}
                            </a>
                        </li>
                        <template v-if="false">
                        <li class="menu" @click="toggleMobileMenuXXX">
                            <a :href="'https://hydrasurvey.ca/services/hydrographic-sludge-surveys-2'" 
                                aria-expanded="false" class="dropdown-toggle" target="_blank">
                                <div class="" style="display: flex; align-items: flex-start;">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="feather feather-droplet"
                                        style="flex-shrink: 0; margin-top: 2px;"
                                    >
                                        <path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"/>
                                    </svg>
                                    <span style="white-space: normal; word-break: break-word;">Sludge/Sediment Surveys</span>
                                </div>
                            </a>
                        </li>
                        <li class="menu" @click="toggleMobileMenuXXX">
                            <a :href="'https://hydrasurvey.ca/projects-1'" aria-expanded="false" class="dropdown-toggle" target="_blank">
                                <div class="">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="feather feather-briefcase"
                                    >
                                        <rect x="2" y="7" width="20" height="14" rx="2" ry="2"/>
                                        <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
                                    </svg>
                                    <span>Projects</span>
                                </div>
                            </a>
                        </li>
                        
                        
                        </template>
                         
                    </template>
                </ul>
                
                 <!--PROJECT PICKER-->
                <NavPicker v-if="customerhub"
                :allProjects="mapProjects"
                />

            </div>
            <!--FILE SYSTEM NAVIGATION-->
            <FileNavigator v-if="site" ref="fileNavRef" :clientId="clientId" :projectId="projectId" @loaded="treeDataIsReady"/>
           
        </nav>
        <T3dviewInstruction />
    </div>
    <!--  END SIDEBAR  -->
</template>

<script setup>
    import { useRoute } from 'vue-router';
    import { onMounted, ref, inject, watchEffect, computed, watch, nextTick} from 'vue';
    import { useStore } from 'vuex';
    import dbProjectReadWrite from '@/composables/fe_dbProjectReadWrite';
    import useFeLocalStorage from '@/composables/useFeLocalStorage';
    import swapProjects from '@/composables/swapProjects';
    import personData from '@/composables/fe_personData'
    import FileNavigator from '@/components/layout/filenavigator';
    //import { frontendRoot } from '/src/composables/apiLink.js'
    import NavPicker from '@/components/layout/navpicker';
    import { useGlobals} from '@/composables/globals'
    import T3dviewInstruction from '@/views/components/T3dviewInstruction.vue';


    const mainReportFileExists = ref(true)
    const specialpage = ref('')
    //const treeDataBasics = ref("")
    const {cells, mapProjects, relatedProjects, currentProject} = useGlobals()
    const fileNavRef = ref(null)
    const mainReport = ref(null)

    const mainreport = () => {
        if (!mainReport.value) {
            alert("Main report not found in file tree. Please contact HydraSurvey to resolve this issue.")
            return
        }
        fileNavRef.value?.openMainReport(mainReport.value);
    }
    const homepageonly = computed(() => {
        return route.path === '/' || route.path === ''
    })

    // const selectedFolder = computed(() => 
    //     folderStack.value[folderStack.value.length - 1] ?? null
    // )

    //fn const folderStack = ref([])

    // const currentPath = computed(() => 
    //     folderStack.value.map(f => f.text).join('/')
    // )

    // const folderContents = computed(() => 
    //     selectedFolder.value ? selectedFolder.value.children : treeData.value
    // )

    // const currentFolders = computed(() =>
    //     folderContents.value.filter(n => n.children && n.children.length > 0 
    //         && !n.text?.toLowerCase().startsWith('__') 
    //         && !n.text?.toLowerCase().endsWith('.db'))
    // )

    // const currentFiles = computed(() =>
    //     folderContents.value.filter(n => !n.children || n.children.length === 0)
    // )

    // TODO STEVEN - implement download buttons + 3D view
    const comingSoon = () => {
        store.commit('TRIGGER_3D_NUDGE');
        setTimeout(() => {
            alert('This feature is coming soon!');
        }, 200);
        
    }
    const noLink = (type) => alert("No " + type + " link found!")
    const lastSegment = ref("")

    const { loadDataProjList } = dbProjectReadWrite();
    const { onSubmitProjectId, getRecentProjects } = swapProjects();
    const { getErrorCount } = personData()
    //const { getFiles, viewFile, zipFiles } = projectData()
    
    var HsGlobals = inject('HsGlobals')
    const route = useRoute()
    const store = useStore();
    const project = ref(store.state.fe_project)
    const projectId = ref(0)
    const clientId = ref(0)
    const discmoneysummaryurl=ref('')
    const discwbssummaryurl=ref('')
    const discdwghrsurl=ref('')
    const mastersummaryurl = ref('')
    const timesummaryurl = ref('')
    
    // const discmoneysummaryurlT=ref('')
    // const discwbssummaryurlT=ref('')
    // const mastersummaryurlT = ref('')
    // const timesummaryurlT = ref('')

    const forceHideMenu = ref(false) 
    const lcrAccess = ref(false)
    const admin = ref(false)
    const username = ref('')
    const extraInfo = ref()
    const projectsToDisplay = ref([])
    const numberOfProjectsToDisplay = 4
    const errorCount = ref(0)
    const peopleErrorCount = ref(0)
    const HsLocalInfo = useFeLocalStorage('30baab36-b0ca-4e4e-9e33-827d5c9c6096', {
        "projectId":null, 
        "projectName":null, 
        "currentUser":null, 
        "SSRSReportPath":null, 
        "SSRSReportPath":null 
    })
    const gotoUrl = ref(useRoute().query.goto)
  
    const menu_collapse = ref('dashboard');

    const years = ref([2024, 2025, 2026])
    const locations = ref (["Nanton", "Calgary", "Edmonton"])
    const projs = ref(["26001 Site 1", "25034 Site 2", "25046 Site 3"])

    const site = ref(false)
    const customerhub = ref(false)
    

    console.log('route',route)
    
    const handle3dInstructionClick = () => {
        store.commit('TRIGGER_3D_NUDGE');
    };

    //const optionlist = ref([])

    // const hideMobileMenu = () => {
    //     forceHideMenu.value = true
    //     store.commit('hideSideBar');
    // };


    //watch for the query request to return
    watchEffect(() => {
   
        if (route.path.includes("faq")) {
            specialpage.value = 'page-faq' //turn off border as customer requested
        } 

        // console.log(route.path, route.params.projectId, "######")
        if (route.path.includes("users") 
            || route.path.includes("projectlist") 
            || route.path.includes("clientlist")
            || route.path.includes("pages/faq")) {

                console.log("Special page, hiding menu")
                setTimeout(() => {
                    console.log("delayed close")
                    forceHideMenu.value = true
                    toggleMobileMenu()
                    //store.commit('toggleSideBar',false)
                }, 100);
           
        }
        if (route.path.includes("site")) {
            site.value = true
        } else if (route.path.includes("customerhub")) {
            customerhub.value = true
        } else {
            site.value = false
            customerhub.value = false
        }
        if (route.params.projectId) {
            projectId.value = route.params.projectId
            clientId.value = route.params.clientId
        }
        // if (route.params.projectId) {
        //     projectId.value = route.params.projectId
        //     clientId.value = route.params.clientId
        //     Promise.all([
        //         getFiles(clientId.value, projectId.value)
        //     ])
        //     .then(res => {
        //         treeData.value = res[0]
        //         const mainReportRegex = new RegExp("Report\.[0-9]{4}\.[0-9]{2}\.[0-9]{2}")
        //         mainReport.value = treeData.value.find(f => {
        //             // console.log(f.text, mainReportRegex.test(f.text), "@@@")
        //             return mainReportRegex.test(f.text)
        //         })
        //     })
        // }

        
    })
    const mainFileReportClass = ref('')

    function treeDataIsReady(value) {
        console.log("treeDataIsReady with main report value:", value);
        mainFileReportClass.value = ''
        if (!value || typeof value === 'undefined' || value.text === "") {
            mainFileReportClass.value = 'text-danger'
            
            
        } else if (value.text?.toLowerCase().startsWith("~~no_main_report")) 
        {
            
            mainReportFileExists.value = false
        }
        mainReport.value = value
    }

    watch(currentProject, () => {
        console.log(currentProject, "@@@")
        if (currentProject.value.mainReportOverride && currentProject.value.mainReportOverride != "") {
            mainReport.value = {text: currentProject.value.mainReportOverride}
        }
        // let mainReportOverride = cells.value.filter(c => c.cellHeader == "_Main Report" && c.cdStr1)
    })

    const gpsState = computed(() => {
        if (cells.value) {
            
            let links = cells.value.filter(c => c.cellHeader === "_GPS Link" && c.cdStr1)
            links = links.map(c => ({ cellName: cells.value.find(n => n.cellHeader === "Cell name" && n.cellId === c.cellId).cdStr1, gpsLink: c.cdStr1 }))
            const uniqueLinks = [...new Set(links.map(c => c.gpsLink))]

            if (links.length === 0) return { type: 'none' }
            if (uniqueLinks.length === 1) return { type: 'single', link: uniqueLinks[0] }
            return { type: 'multiple', links }
        }
    })

    const siteTourState = computed(() => {
        if (cells.value) {
            console.log(cells.value.links, "@@@@links")
            let links = cells.value.filter(c => c.cellHeader === "_Virtual Tour" && c.cdStr1)
                              


            links = links.map(c => ({ cellName: cells.value.find(n => n.cellHeader === "Cell name" && n.cellId === c.cellId).cdStr1, virtualSiteTourLink: c.cdStr1 }))
            const uniqueLinks = [...new Set(links.map(c => c.virtualSiteTourLink))]
          
            if (links.length === 0) return { type: 'none' }
            if (uniqueLinks.length === 1) return { type: 'single', link: uniqueLinks[0] }
            return { type: 'multiple', links }
        }
    })
  


    onMounted(() => {

        const urlParams = new URLSearchParams(window.location.search)
        if (urlParams.get('pid')) {
            onSubmitProjectId(urlParams.get('pid'), true, false)
        }

        window.addEventListener("peopleerrorsupdate", (event) => {
            adjustErrors()
        })

        // console.log('route[query]',route)
        window.addEventListener('30baab36-b0ca-4e4e-9e33-827d5c9c6096-localstorage-changed', (event) => {
            try {

                console.log("******* Project (sidebar) *********** HERE1",event)
                if (event.detail.storage !== null){

                let g = event.detail.storage

                if (!(projectId.value>0)) { //we might already have received it from the routes.params.projectId
                    projectId.value = g.projectId 
                }
                extraInfo.value = g

                if (extraInfo.value) {
                    console.log("******* Project (sidebar) *********** HERE1a", extraInfo.value)
                    //console.log("******* Project (sidebar) *********** extraInfo ",extraInfo.value)
                    if (extraInfo.value.SSRSReportPath) {
                        console.log("******* Project (sidebar) *********** HERE1b",projectId.value)
                        extraInfo.value.SSRSReportPath = ''
                        discmoneysummaryurl.value = ''
                        mastersummaryurl.value = ''
                        discwbssummaryurl.value = ''
                        discdwghrsurl.value = ''
                        timesummaryurl.value = ''


                              }
                    if (extraInfo.value.LCRAccess && extraInfo.value.LCRAccess == "True") {
                        lcrAccess.value = true
                    }
                    if (extraInfo.value.Admin && extraInfo.value.Admin == "True") {
                        admin.value = true
                    }
                    if (extraInfo.value.username) {
                        username.value = extraInfo.value.username
                    }       
                }

                //load in the projects
                //might not need this. I'll just use local storage
                //as that appears to be where we are storing the status
                //of the projects
                
                //console.log("******* Project (sidebar) *********** Value Has Changed-Window Event",event, g)
                }
            } catch (err) {
                projectId.value = 0
                //console.log("******* Project (sidebar) *********** ERROR",err)
                
            }

        });

        const selector = document.querySelector('#sidebar a[href="' + window.location.pathname + '"]');
        if (selector) {
            const ul = selector.closest('ul.collapse');
            if (ul) {
                let ele = ul.closest('li.menu').querySelectorAll('.dropdown-toggle');
                if (ele) {
                    ele = ele[0];
                    setTimeout(() => {
                        ele.click();
                    });
                }
            } else {
                selector.click();
            }
        }
    });

 
    

    const toggleMobileMenu = () => {
        console.log("Toggling mobile menu1. Current state:", store.state.is_show_sidebar, "Force hide:", forceHideMenu.value);
        if (forceHideMenu.value) {
            console.log("Toggling mobile menu111. Current state:", store.state.is_show_sidebar, "Force hide:", forceHideMenu.value);
            store.commit('toggleSideBar', true);
            if (window.innerWidth >= 991) {
                store.commit('toggleSideBar', false);
            }
        } else if (window.innerWidth < 991) {
            console.log("Toggling mobile menu2. Current state:", store.state.is_show_sidebar, "Force hide:", forceHideMenu.value);
            store.commit('toggleSideBar', !store.state.is_show_sidebar);
        }
    };

</script>
<style scoped>
    #sidebar ul.menu-categories li.menu > .dropdown-toggle .inputmenu,
    #sidebar ul.menu-categories ul.submenu.underlying > li a
     {
        color:darkblue;
    }
    #sidebar ul.menu-categories li.menu > .dropdown-toggle .inputmenu:hover,
    #sidebar ul.menu-categories ul.submenu.underlying > li a:hover
     {
        color:rgb(0, 110, 255);
    }
    #sidebar ul.menu-categories li.menu > .dropdown-toggle .reportmenu {
        color: darkgreen;
    }

    #sidebar ul.menu-categories li.menu > .dropdown-toggle .reportmenu:hover {
        color: rgb(1, 165, 1);
    }

    .hover:hover {
        cursor: pointer;
    }

    .recentproject {
        color:purple;
    }

    #sidebar ul.menu-categories li.menu > .dropdown-toggle svg.recentitems {
        margin-right: 4px;
    }

    .badge {
        border-radius: 0.700rem;
        display:inline;
    }
    #sidebar ul.menu-categories ul.submenu > li a.peopleitem {
        display:inline;
    }
    #sidebar ul.menu-categories ul.submenu > li a.peopleitem2 {
        display:inline;
        margin-left:0px;
        padding-left:0px;
    }

    .overflow-enabled {
        overflow: visible!important;
    }
    #sidebar ul.menu-categories li.menu > .recentprojectanchor {
        padding: 1px 11px !important; 
    }

    .mtl-tree {
        padding: 11px 14px;
        height: 25%;
        overflow-y: scroll!important;
    }

    .filter-item {
        overflow: visible!important;
        white-space: nowrap;
        text-overflow: ellipsis;
        max-width: 150px;
        vertical-align: middle;
    }

    .filter-item:hover {
        color: blue;
        cursor: pointer;
    }

    .mtl-checkbox {
        width: 14px;
        height: 14px;
        flex-shrink: 0;
        vertical-align: middle;
        margin-right: 4px;
        cursor: pointer;
        accent-color: #4a90e2; /* optional: matches your theme */
    }

    .btn2 {
        width: 50%;
        margin: 1px;
    }

    .project-link {
        color: inherit;
        text-decoration: none;
        text-transform: uppercase;
    }
    .project-link:hover {
        color: #4a90e2;
    }

</style>

<style>


.simplebullet {
    padding-left:0px;

}
.simplebullet li {
    padding-left:0px;
}
.sidebar-wrapper {
    left: 0px;
    width: 247px;

    margin-bottom:20px;


    height: calc(100vh - 105px); /* Your requested height */

/* ADD THESE TO CONTROL THE STACK */
    display: flex;
    flex-direction: column;
    overflow: hidden; /* Prevent the container itself from scrolling */


}
#sidebar {
    width:245px;
    border: 3px solid hsl(6.05deg 67.23% 34.71%);

}
.map-container {
    border: #2f4f53 2px solid;
}


.bottombullet li a div {
    background-color: #497a82;
    border-radius: 99px;
    color: white;
    font-weight: bold;
    list-style: none; /* Optional: removes the bullet point */
    padding:10px;
    

}
.bottombullet li a div span{
    padding-left:10px;
}
.sidebar-container {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 107px) !important; /* Or 100% of the parent */
}
#sidebar ul.menu-categories.ps.site{
    height: unset !important;
    min-height:50% !important;
}
/* The top part of your menu (the other <ul> or div) */

.shadow-bottom {
    z-index: 100;
}

.top-menu-items {
    z-index: 101;
    flex-grow: 1; /* This "pushes" everything else down */
     border-top: 3px solid hsl(6.05deg 67.23% 34.71%);

}
.bottombullet {
    margin-top: auto; /* The final nudge to stay at the bottom */
    padding: 10px 4px;
    list-style: none;
    border-top: 3px solid hsl(6.05deg 67.23% 34.71%);
}

/* .layout-px-spacing {
    padding: 0 0px 0 18px !important;
} */

.splitmenu {
    margin-left: 7px;
    margin-top:10px;

    font-size: larger;
    font-weight: bold;

        margin-bottom: -10px !important;
        color: #497a82;
}

ul.simplebullet li.menu span{

    color:#497a82;
}
ul.simplebullet li.menu a {
    list-style: none;
    padding-left: 0px;
    padding-top:0px !important;
    color:#497a82;
}

#sidebar ul.simplebullet li.menu > .dropdown-toggle {
    padding-top:0px
   
}
.asksurvey {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    width: 247px;
    border-bottom: 3px solid hsl(6.05deg 67.23% 34.71%);
    padding-bottom: 10px;
}
.asksurvey img {
    width: 200px;
    margin-left: 5px;
    background-color: transparent;
}
/* .root-item {
    border-top: 3px solid hsl(6.05deg 67.23% 34.71%);
    padding-bottom:0px
}
.mtl-tree.folder-list {
    width: 100%;
    padding-top:0px;
    border-bottom: 3px solid hsl(6.05deg 67.23% 34.71%);
}
.mtl-tree.file-list {

    border-bottom: 3px solid hsl(6.05deg 67.23% 34.71%);
} */

.menu {

    padding-left:10px;
    padding-top:2px;
}
.menu a {
    cursor: pointer;
}
 
.first-site-menu {
    margin-top:20px;
}
.top-menu-items.menu-section {
    padding-top:10px;
    overflow-y: auto !important;
    overflow-x: hidden;
}
.project-link {
    font-size:smaller;
    margin-left:10px;
}
.related-header {
   padding-top:10px;
   margin-left:10px;
   margin-bottom:0px;
   padding-bottom: 0px;
}


.page-faq #sidebar, .page-faq .sidebar-container {
    
    border: none !important;
    border-color: green !important;
}
.page-faq .sidebar-container {
    
    border: none !important;
    border-color: green !important;
}

/* replace perfectscrollbar */
.custom-sidebar-scroll {
    overflow-y: auto !important;
    overflow-x: hidden !important;
    max-height: 100vh; /* Adjust if your header offsets the sidebar height */
}

/* Elegant, thin scrollbar tracking for modern browser layouts */
.custom-sidebar-scroll::-webkit-scrollbar {
    width: 6px;
}
.custom-sidebar-scroll::-webkit-scrollbar-track {
    background: transparent;
}
.custom-sidebar-scroll::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.25);
    border-radius: 3px;
}
.custom-sidebar-scroll {
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.25) transparent;
}

</style>
